/**
 * ──────────────────────────────────────────────────────────────────────────
 *  CONTEXT-LOCKED PALETTE — Camera Line-of-Sight Viewshed family (#178
 *  Cesium-wow; operator-cop-doctrine §3A.7, §8.4 colour law). 2026-06-08.
 *
 *  The SINGLE source of the modelled-viewshed render's colours. Consumed ONLY by
 *  the camera-viewshed family:
 *    - the CameraViewshedLayer translucent ground-draped VISIBLE footprint
 *    - the CameraViewshedControl legend swatch
 *
 *  Colour law: the viewshed family is a CALM SIGHTLINE TEAL (#2dd4bf), painted at
 *  low alpha and ground-draped. Deliberately NOT urgent-red and NEVER pulsing:
 *  URGENT-RED + motion are RESERVED for the Anomaly-Queue / Urgent-Alerts surface
 *  (Colour Law 6 motion budget), and a big occluded-red field would collide with
 *  that layer — so v1 paints ONLY the area the camera CAN see and leaves the
 *  occluded ground UNpainted (the un-teal shadow behind a ridge reads the occlusion
 *  on its own). Teal is distinct from the flood family's water-blue/cyan
 *  (floodInundation), the live-camera emerald glow, the amber camera-smoke glyph,
 *  and the outage red — so "what this camera sees" never reads as any of them.
 *  Colour is never load-bearing alone: the layer is labelled "(modelled)" and the
 *  control legend names the footprint + the assumptions.
 *
 *  ⛔ Do NOT import another family's palette here (enforced by the
 *     no-restricted-imports lint rule in eslint.config.js).
 * ──────────────────────────────────────────────────────────────────────────
 */

/** The visible-footprint fill (sightline teal). */
export const VIEWSHED_VISIBLE_CSS = '#2dd4bf';
/** Footprint alpha — translucent so the draped terrain + basemap read through it. */
export const VIEWSHED_VISIBLE_ALPHA = 0.28;

/** A brighter teal edge on the footprint outline so the visible/occluded boundary
 *  (the ridge-line shadow edge) reads crisply against the terrain. */
export const VIEWSHED_OUTLINE_CSS = '#5eead4';
export const VIEWSHED_OUTLINE_ALPHA = 0.85;
export const VIEWSHED_OUTLINE_WIDTH = 2;

/** Legend copy — the honesty framing the prompt + colour law require. */
export const VIEWSHED_LEGEND = {
  title: 'Camera Line-of-Sight — MODELLED',
  visible: 'Ground the camera can see (clear line of sight)',
  disclaimer:
    'Modelled line-of-sight · terrain only (excludes vegetation & buildings) · assumes ~15 m camera mount height · not a survey product. Backs the camera-smoke fusion (does this camera actually see the fire over that ridge?).',
} as const;
